import React from "react";

export const SEARCH_STATUS = {
  con_resultados: { label: "Con resultados", cls: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  sin_resultados: { label: "Sin resultados con estos filtros", cls: "bg-gray-100 text-gray-700 border-gray-300" },
  fuente_no_disponible: { label: "Fuente no disponible", cls: "bg-amber-50 text-amber-900 border-amber-300" },
  consulta_fallida: { label: "Consulta fallida", cls: "bg-rose-50 text-rose-800 border-rose-300" },
  parcial_con_fallos: { label: "Sin resultados; algunas fuentes fallaron", cls: "bg-amber-50 text-amber-900 border-amber-300" },
};

export function StatusPill({ status, testId }) {
  const m = SEARCH_STATUS[status] || { label: status, cls: "bg-gray-100 text-gray-700 border-gray-300" };
  return <span data-testid={testId} className={`inline-block border px-1.5 py-0.5 text-[10px] uppercase tracking-wide ${m.cls}`}>{m.label}</span>;
}

export function SecopSearchTrace({ steps, compact = false }) {
  return (
    <ul className={`mt-2 space-y-1 ${compact ? "text-[11px]" : "text-xs"}`} data-testid="secop-search-trace">
      {steps.map((s, i) => (
        <li key={i} className="text-gray-600" data-testid={`secop-trace-step-${i}`}>
          <div className="flex flex-wrap items-center gap-2">
            <span className="font-mono text-gray-400">{i + 1}.</span>
            <span className="text-gray-800">{s.platform || s.source_label}</span>
            <span>· {s.scope_label}</span>
            <StatusPill status={s.status} testId={`secop-trace-status-${i}`} />
            {s.count > 0 && <span className="text-emerald-700">{s.count} candidatos nuevos</span>}
          </div>
          {s.territories?.length > 0 && s.scope !== "nacional" && (
            <p className="pl-5 text-gray-500 truncate" title={s.territories.join(", ")}>{s.territories.join(", ")}</p>
          )}
        </li>
      ))}
    </ul>
  );
}
